import { normalizeApiDate } from "@fp/ui/utils/date";
import { formatDistanceStrict } from "date-fns";

const JUST_NOW_THRESHOLD_MS = 60_000;
const MAX_BADGE_COUNT = 99;

export function formatNotificationAge(createdDate: string, now: Date): string {
  const created = new Date(normalizeApiDate(createdDate));
  const elapsedMs = now.getTime() - created.getTime();

  if (elapsedMs < JUST_NOW_THRESHOLD_MS) {
    return "Just now";
  }

  return `${formatDistanceStrict(created, now, { roundingMethod: "floor" })} ago`;
}

export function formatUnreadBadge(unreadCount: number): string | null {
  if (unreadCount <= 0) {
    return null;
  }

  return unreadCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : `${unreadCount}`;
}